"use strict";

import jQuery from 'jquery';

/**
 * @classdesc
 * Layerkatalog-Panel (intern)
 *
 * @class
 * @extends gc.gis.widget.GCWidget
 * @memberof gc.gis.module.GCLayerCatalog
 * @author Anton Popov <a.popov@brain-scc.de>
 *
 * @param {Object} options Aufrufoptionen
 * @param {gc.gis.module.GCLayerCatalog} options.module Modul-Instanz
 */
gc.gis.module.GCLayerCatalog.Panel = function(options)
{
	gc.gis.widget.GCWidget.call(this, options);

	gc.gis.assert.isSet(options);
	gc.gis.assert.isInstance(options.module, gc.gis.module.GCLayerCatalog);

	this.module  = options.module;
	this.element = this._render();
};
gc.gis.module.GCLayerCatalog.Panel.prototype = Object.create(gc.gis.widget.GCWidget.prototype);

/**
 *
 */
gc.gis.module.GCLayerCatalog.Panel.prototype._render = function()
{
	var self = this;

	// Tab panels
	var input_internal_search = jQuery('<input>', {
		'class': 'form-control control-input',
		type: 'text',
		placeholder: 'Ebenenbezeichnung'
	});

	var hint_internal_search = jQuery('<div>', {
		'class': 'gc-form-internal-search-hint bg-warning',
		html: '<span><kbd>Enter</kbd> zum bestätigen drücken.</span>'
	});
	input_internal_search.on('change', function( evt ) {
		if( hint_internal_search.is(':visible') )
		{
            hint_internal_search.hide('blind');
		}
	});
	input_internal_search.on('keyup', function( evt ) {
		// console.log(jQuery(this).val());
		if( jQuery(this).val() !== '' )
		{
			if( !hint_internal_search.is(':visible') )
			{
				hint_internal_search.show('blind');
			}
		}
		else if( hint_internal_search.is(':visible') )
		{
			hint_internal_search.hide('blind');
		}
	});
	input_internal_search.on('blur', function( evt ) {
		if( hint_internal_search.is(':visible') )
		{
			hint_internal_search.hide('blind');
		}
	});

	var label_internal_search = jQuery('<label>', {
		'class': 'form-group input-group',
		html: jQuery('<span>', {
			'class': 'input-group-addon gc-label-search',
			text: 'Suche:'
		})
	});
	label_internal_search.append(' ').append( input_internal_search );
	var reset_internal_search = jQuery('<input>', {
		'class': 'gc-control-reset btn btn-default',
		title: 'Zurücksetzen',
		value: 'X',
		type: 'reset'
	});
	reset_internal_search.on('click', function( evt ) {
		self.module.findInternalLayers('');
		jQuery(this).blur();
	});
	label_internal_search.append( jQuery('<span>', {
		'class': 'input-group-btn',
		html: reset_internal_search
	}) );
	gc.gis.iface.ui.tooltip(reset_internal_search);

	this.form_internal_search = jQuery('<form>', {
		'class': 'gc-form-internal-search'
	});
	this.form_internal_search.on('submit', function( evt ) {
		evt.preventDefault();
		self.module.findInternalLayers( input_internal_search.val() );
	});
	this.form_internal_search.append( label_internal_search );

	this.form_internal_search.append( hint_internal_search );
	hint_internal_search.hide();

	this.form_internal = jQuery('<form>', {
		'class': 'gc-form-internal-content'
	});
	this.actionbar_internal = new gc.gis.widget.GCWidgetGroup({
		containerClassName: 'gc-form-internal-actionbar',
		items: [
			new gc.gis.widget.GCItem({
				label: 'Auswahl laden',
				className: 'btn btn-success',
				//icon: 'glyphicon glyphicon-ok',
				action: new gc.gis.action.layercatalog.LoadInternalLayers( self.module )
			}),
			new gc.gis.widget.GCItem({
				label: 'Zurücksetzen',
				className: 'btn btn-default',
				//icon: 'glyphicon glyphicon-retweet',
				action: new gc.gis.action.layercatalog.ResetInternalLayers( self.module )
			})
		]
	});

	this.element = jQuery('<div>', {
		'class': 'internal-catalog catalog-panel active'
	});
	this.element
		.append( this.form_internal_search )
		.append( this.form_internal )
		.append( this.actionbar_internal.getElement() );

	return this.element;
};

/**
 *
 */
gc.gis.module.GCLayerCatalog.Panel.prototype.renderInternalLayerTree = function( data, opt_hilite, opt_expand )
{
	gc.gis.assert.isArray( data );

	this.form_internal.children().remove();

	if( data.length > 0 )
	{
		var list = jQuery('<ul>', {
			'class': 'gc-items'
		});

		var li;
		for( var i=0; i<data.length; i++ )
		{
			li = jQuery('<li>');
			li.append( this.renderInternalLayer( data[i], false, opt_hilite ) );
			list.append( li );
		}

		this.form_internal.append( list );

		if( opt_expand === true )
		{
			this.form_internal.find('.gc-item-action-expand').click();
		}
	}
	else
	{
		var p_message = jQuery('<p>', {
			'class': 'gc-empty',
			html: '<em>'+ (opt_hilite ? 'Nichts gefunden.' : 'Keine Ebenen verfügbar.') +'</em>'
		});
		this.form_internal.append( p_message );
	}

	this.form_internal.show('blind');
};

/**
 *
 */
gc.gis.module.GCLayerCatalog.Panel.prototype.renderInternalLayer = function( layer, selected, opt_hilite )
{
	gc.gis.assert.isSet( layer ).notNull( layer );

	var self = this;

	// Checkbox
	var ck_label = jQuery('<input>', {
		type: 'checkbox',
		value: layer.name
	});
	ck_label.prop('checked', selected );
	ck_label.on('change', function( evt ) {
		var checked = jQuery(this).is(':checked');

		// Selected-Status auf den Layer setzen
		jQuery(this).data('__layer').checked = checked;

		// Entfernen, wenn parent schon selektiert
		if( checked && jQuery(this).data('__layer').parent_checked )
		{
			delete jQuery(this).data('__layer').checked;
		}

		// Kinder (de-)selektieren
		var children = jQuery(this)
			.parent().parent().siblings('.gc-item-body').find('input[type=checkbox]');

		children.prop('checked', checked );
		children.each( function( idx, ck ) {
			delete jQuery(ck).data('__layer').checked;
			jQuery(ck).data('__layer').parent_checked = checked;
		});
	});
	ck_label.data('__layer', layer );

	// Label
	var label_text = layer.label || layer.defaultLabel;

	if( opt_hilite )
	{
		var re = new RegExp('('+ opt_hilite +')', 'gi');	// FIXME: Ggf. XSS/HTML-injection: http://stackoverflow.com/a/280837
		label_text = label_text.replace( re, '<strong class="gc-highlight">$1</strong>');
	}

	var group_count;
	if( layer.items )
	{
		group_count = ' <span class="gc-group-count">('+ layer.items.length +')</span>';
	}
	else if( typeof layer.item_count === 'number' )
	{
		group_count = ' <span class="gc-group-count">('+ layer.item_count +')</span>';
	}

	var div_label = jQuery('<div>', {
		'class': 'gc-item-head'
	});
	var lbl_label = jQuery('<label>', {
		'class': 'gc-item-label'+ (layer.originalType ? ' '+layer.originalType : ''),
		html: ' <span class="gc-item-label-text">'+ label_text +'</span>'
		    +( group_count ? group_count : '')
	});
	lbl_label.prepend( ck_label );

	var ms_ico_dict = {
		'group':   'ms ms-directory-open',
		'wms':     'ms ms-ogc-wms',
		'wfs':     'ms ms-ogc-wfs',
		'postgis': 'ms ms-postgis',
		'fachdb':  'ms ms-database',
		'file':    'ms ms-txt',
		'atkis':   'ms ms-ogc-gml'
	};
	var div_info = jQuery('<div>', {
		'class': 'gc-item-info',
		html: ' <span class="gc-item-type gc-layer-type-'+ layer.originalType +'"'
			+' title="Typ: '+ this.__lookupLayerType( layer.originalType ) +'">'
			+'<span class="gc-icon '+ms_ico_dict[layer.originalType]+'"></span>'
			+'<span class="gc-item-type-text">('+ layer.originalType +')</span>'
			+'</span>'
	});

	var div = jQuery('<div>', {
		'class': 'gc-item gc-collapsed'
	});

	// Untergruppen
	if( layer.items || layer.item_count )
	{
		var btn_node = jQuery('<button>', {
			'class': 'gc-item-action gc-item-action-expand',
			title: 'Gruppe auf-/zuklappen',
			html: '<span class="gc-icon icon"></span><span>Gruppe auf-/zuklappen</span>'
		});
		var ul_items = jQuery('<ul>', {
			'class': 'gc-items'
		});
		var div_loading = jQuery('<div>', {
			'class': 'gc-item-loading',
			html: '<span>Lade Inhalte...</span>'
		});
		div_loading.hide();

		if(layer.items)
		{
			btn_node.data('__state', true );	// offen
			btn_node.on('click', function( evt ) {
				evt.preventDefault();

				var state  = btn_node.data('__state');

				btn_node.data('__state', !state );
				ul_items.toggle('blind');

				if( state )
				{
					btn_node.addClass('active');
					div.addClass('gc-expanded').removeClass('gc-collapsed');
				}
				else
				{
					btn_node.removeClass('active');
					div.addClass('gc-collapsed').removeClass('gc-expanded');
				}
				// self.form_internal.trigger('heightChange');

				return false;
			});

			var li;
			for(var i=0; i<layer.items.length; i++)
			{
				li = jQuery('<li>');
				li.append( this.renderInternalLayer(layer.items[i], selected, opt_hilite));
				ul_items.append(li);
			}
		}
		else if( layer.item_count )
		{
			btn_node.data('__state', true );	// offen
			btn_node.on('click', function( evt ) {
				evt.preventDefault();

				var state  = btn_node.data('__state');
				var loaded = btn_node.data('__loaded');

				if(!loaded && state)
				{
					div_loading.show('blind');

					var url = gc.gis.GCUrl.buildUrl(self.module.update_url, {cat: layer.id});
					gc.gis.iface.request.ajax({	// FIXME: move to module
						label: 'Lade Kategorie ... ',
						context: self,
						url: url,
						dataType: gc.gis.util.GCRequestManagerDataType.JSON,

						success: function(result)
						{
							try
							{
								var checked = ck_label.is(':checked');
								var items = result.results;

								// Ergebnis "Reversen", da OL Layer intern umgekehrt organisiert, als die Legende aufgebaut ist
								layer.items = items.reverse();
								ck_label.data('__layer', layer);
								var li;
								ul_items.children().remove();
								for(var i=items.length - 1; i>=0; i--)
								{
									li = jQuery('<li>');
									li.append(self.renderInternalLayer(items[i], checked, opt_hilite));
									ul_items.append( li );
								}
								btn_node.data('__loaded', true );
								ck_label.data('__loaded', true );
							}
							catch( err )
							{
								gc.gis.iface.log.error( this, err );

								ul_items.children().remove();
								ul_items.append( jQuery('<li>', {
									'class': 'gc-error',
									html: '<strong>Fehler beim Laden:</strong> '+ err
								}) );
							}
							btn_node.data('__state', !state );
							div_loading.hide('blind');
							ul_items.show('blind');
							btn_node.addClass('active');
							div.addClass('gc-expanded').removeClass('gc-collapsed');
						},
						error: function( err ) {
							ul_items.children().remove();
							ul_items.append( jQuery('<li>', {
								'class': 'gc-error',
								html: '<strong>Fehler beim Laden:</strong> '+ err
							}) );
							btn_node.data('__state', !state );
							div_loading.hide('blind');
							ul_items.show('blind');
							btn_node.addClass('active');
							div.addClass('gc-expanded').removeClass('gc-collapsed');
						}
					});
				}
				else
				{
					ul_items.toggle('blind');
					btn_node.data('__state', !state );
					if( state )
					{
						btn_node.addClass('active');
						div.addClass('gc-expanded').removeClass('gc-collapsed');
					}
					else
					{
						btn_node.removeClass('active');
						div.removeClass('gc-expanded').addClass('gc-collapsed');
					}
				}
				// self.form_internal.trigger('heightChange');
				jQuery(this).blur();
				return false;
			});
		}
		// btn_node.click();

		var div_items = jQuery('<div>', {
			'class': 'gc-item-body'
		});
		div_items.append( div_loading ).append( ul_items );
		div_label.append( btn_node ).append( lbl_label ).append( div_info );
		div.append( div_label ).append( div_items );
		ul_items.hide();
	}
	// Nicht-Gruppen
	else if( layer.originalType !== 'group' )
	{
		var a = new gc.gis.action.layer.ShowLayerInfo({
			layer: layer
		});
		var btn_info = jQuery('<button>', {
			'class': 'gc-item-action gc-item-action-info',
			title: 'Ebeneninformationen anzeigen',
			html: '<span class="gc-icon glyphicon glyphicon-info-sign"></span><span>Ebeneninformationen</span>',
			click: function (evt) {
				evt.preventDefault();
				try
				{
					a.execute();
				}
				catch( err )
				{
					gc.gis.iface.log.error( self, err );
				}
				jQuery(this).blur();
			}
		});

		div_info.prepend( btn_info );
		div_label.append( lbl_label ).append( div_info );
		div.append( div_label );
	}
	// Leere Gruppen
	else
	{
		div_label.append( lbl_label ).append( div_info );
		div.append( div_label );
	}
	gc.gis.iface.ui.tooltip(div.find('.gc-item-type, .gc-item-action'), {
		placement: 'auto left'
	});

	return div;
};

/**
 *
 */
gc.gis.module.GCLayerCatalog.Panel.prototype.resetInternalForm = function()
{
	this.form_internal[0].reset();
	this.form_internal.find('input[type=checkbox]').each( function( idx, ck ) {
		delete jQuery(ck).data('__layer').checked;
		delete jQuery(ck).data('__layer').parent_checked;
	});
};

/**
 *
 */
gc.gis.module.GCLayerCatalog.Panel.prototype.showLoadingAnimation = function( label )
{
	this.form_internal.children().remove();

	// Ladeanimation zeigen
	var div_loading = jQuery('<div>', {
		'class': 'item-loading',
		html: '<span>'+ label +'</span>'
	});
	this.form_internal.append( div_loading );
	div_loading.show('blind');
};

/**
 *
 */
gc.gis.module.GCLayerCatalog.Panel.prototype.showError = function( err )
{
	this.form_internal.children().remove();
	this.form_internal.append( jQuery('<p>', {
		'class': 'gc-error',
		html: '<strong>Fehler beim Laden:</strong> '+ err
	}) );
};

gc.gis.module.GCLayerCatalog.Panel.prototype.__lookupLayerType = function( key )
{
	var dict = {
		'group':   'Kategorie',
		'wms':     'WMS-Ebene',
		'wfs':     'WFS-Ebene',
		'postgis': 'Postgis-Ebene',
		'fachdb':  'Fachdatenbank-Ebene',
		'file':    'Datei-Ebene',
		'atkis':   'ATKIS-Ebene'
	};

	return dict[key] || key;
};
